import React, { useEffect } from "react";
import { Table, Button, Modal, Popconfirm, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import { plusicon, searchnormal } from "../../imagepath";
import { useState } from "react";
import { Link } from "react-router-dom";
import DoctorHeader from "../../../doctor/DoctorHeader";
import Sidebar from "../../Sidebar";
import moment from "moment/moment";
import apiClient from "../../../utils/apiClient";
import AddRadiologistSlot from "./AddRadiologistSlot";
import useToast from "../../../hooks/userToast";
import useUser from "../../../hooks/useUser";

const RadiologistSlotsTable = () => {
  const [allSlotsData, setAllSlotsData] = useState();
  const [filterInput, setFilterInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);

  const [addModal, setAddModal] = useState({ isModalOpen: false });
  const { toastSuccess, toastError } = useToast();

  const { isRadiologist, userID } = useUser();

  //AttachmentModal
  const showAddModal = () => {
    setAddModal({ isModalOpen: true });
  };

  const handleOkAddModal = () => {
    setAddModal({ isModalOpen: false });
  };

  const handleCancelAddModal = () => {
    setAddModal({ TextisModalOpen: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`availability/${id}`);
      toastSuccess("Event Deleted Successfully");
      await fetchAllSlotData();
    } catch (error) {
      console.log(error);
      toastError("Error Delteting Event");
    }
  };

  const columns = [
    {
      title: "Radiologist",
      dataIndex: "user.name",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      render: (date) => {
        return <>{moment(date).format("DD/MM/YY")}</>;
      },
    },

    {
      title: "End Date",
      dataIndex: "end_date",
      render: (date) => {
        return <>{moment(date).format("DD/MM/YY")}</>;
      },
    },

    {
      title: "Start Time",
      dataIndex: "start_time",
      render: (time) => moment(time, "HH:mm:ss").format("hh:mm:ss A"),
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      render: (time) => moment(time, "HH:mm:ss").format("hh:mm:ss A"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "15%",
      render: (text, record) => (
        <Tooltip title="Delete">
          <Popconfirm
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Tooltip>
      ),
      align: "center",
    },
  ];

  const fetchAllSlotData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        filterInput !== ""
          ? `availability?${
              isRadiologist ? `radiologistId=${userID}&` : ""
            }page=${currentPage}&search=${filterInput}&limit=${limit}`
          : `availability?${
              isRadiologist ? `radiologistId=${userID}&` : ""
            }page=${currentPage}&limit=${limit}`
      );
      setAllSlotsData(response.data?.Availability);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllSlotData();
  }, [currentPage, filterInput, limit]);

  return (
    <>
      <DoctorHeader />
      <Sidebar id="menu-item3" id1="menu-items3" activeClassName="staff-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body cus_box">
                    {/* Table Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h2>Radiologist Slots</h2>
                            <div className="doctor-search-blk">
                              {!isRadiologist && (
                                <div className="top-nav-search table-search-blk">
                                  <form onSubmit={(e) => e.preventDefault()}>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search here"
                                      value={filterInput}
                                      onChange={(e) => {
                                        setFilterInput(() => e.target.value);
                                      }}
                                    />
                                    <Link className="btn">
                                      <img src={searchnormal} alt="#" />
                                    </Link>
                                  </form>
                                </div>
                              )}
                              <div className="add-group">
                                <Button
                                  className="btn btn-primary add-pluss ms-2"
                                  onClick={() => {
                                    showAddModal();
                                  }}
                                >
                                  <img src={plusicon} alt="#" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /Table Header */}
                    <div className="table-responsive doctor-list">
                      <Table
                        className="radiologistslot_table_border"
                        loading={loading}
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={allSlotsData?.data}
                        pagination={{
                          total: allSlotsData?.total,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: (page) => {
                            setCurrentPage(page);
                          },
                          showSizeChanger: true,
                          onShowSizeChange: (current, size) => setLimit(size),
                          showQuickJumper: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title="Add Slot"
          className="ModalFooterHide"
          open={addModal.isModalOpen}
          onOk={handleOkAddModal}
          onCancel={handleCancelAddModal}
          maskClosable={false}
          destroyOnClose
          centered
        >
          <AddRadiologistSlot
            fetchData={fetchAllSlotData}
            handleClose={handleOkAddModal}
          />
        </Modal>
      </>
    </>
  );
};

export default RadiologistSlotsTable;
